<mat-card class="test-section z2-elevation mat-elevation-z2">
  <mat-card-content>
    <!-- Section heading -->
    <div class="test-section__heading-wrapper">
      @if (editMode) {
        <button
          class="test-section__delete-btn"
          mat-mini-fab
          color="warn"
          (click)="removeSection()"
          matTooltip="Delete test section"
          aria-label="Delete test section"
        >
          <mat-icon>delete</mat-icon>
        </button>
      }
      @if (!editingHeading) {
        <h3 id="section-{{ documentNode?.id }}" class="test-section__heading" [class.clickable]="editMode" tabindex="0" (click)="startEditHeading()">
          <span class="test-section__chapter-number" *ngIf="chapterNumber">{{ chapterNumber }}</span>
          <mat-icon class="test-section__icon">checklist</mat-icon>
          {{ heading }}
        </h3>
      } @else {
        <div class="test-section__heading-edit">
          <input matInput class="test-section__heading-input" [formControl]="headingEditControl" placeholder="Section heading" />
          <button mat-icon-button color="primary" (mousedown)="$event.preventDefault()" (click)="saveEditHeading()">
            <mat-icon>check</mat-icon>
          </button>
          <button mat-icon-button (mousedown)="$event.preventDefault()" (click)="cancelEditHeading()"><mat-icon>close</mat-icon></button>
        </div>
      }
    </div>

    <!-- Table header row -->
    <div class="check-grid check-grid--header">
      <div class="check-grid__post">Post</div>
      <div class="check-grid__name"></div>
      <div class="check-grid__executor">Utføres av</div>
      <div class="check-grid__sign">Sign.</div>
      <div class="check-grid__date">Dato</div>
      <div class="check-grid__comments">Bemerkninger</div>
    </div>

    <!-- Check/test rows -->
    @for (node of nodes; track node.id) {
      <div class="test-section__row-wrapper">
        @if (nodeFactory.getComponentForNodeType(node.type); as component) {
          <ng-container *ngComponentOutlet="component; injector: nodeFactory.createInjector(node, parentDocument, injector)"></ng-container>
        }
        @if (editMode) {
          <button
            class="test-section__row-delete"
            mat-icon-button
            color="warn"
            (click)="removeCheckTest(node.id)"
            matTooltip="Remove row"
            aria-label="Remove row"
          >
            <mat-icon>close</mat-icon>
          </button>
        }
      </div>
    }

    <!-- Add check/test button -->
    @if (editMode) {
      <div class="test-section__add-row">
        <button mat-mini-fab color="primary" (click)="addCheckTest()" matTooltip="Add check/test row" aria-label="Add check/test row">
          <mat-icon>add</mat-icon>
        </button>
        <span class="test-section__add-label">Add check / test</span>
      </div>
    }
  </mat-card-content>
</mat-card>
